import { render, staticRenderFns } from "./PopsThirdSubFolderClinic.vue?vue&type=template&id=65b5d721&scoped=true"
import script from "./PopsThirdSubFolderClinic.vue?vue&type=script&lang=js"
export * from "./PopsThirdSubFolderClinic.vue?vue&type=script&lang=js"
import style0 from "./PopsThirdSubFolderClinic.vue?vue&type=style&index=0&id=65b5d721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5d721",
  null
  
)

export default component.exports